<template>
    <div class="m-head">

        <h1 class="logo"><a href="https://www.m3guo.com/v2/" target="_blank"></a></h1>
        <!-- <div class="u-web web-huya"><a href="https://www.huya.com/" target="_blank"></a></div> -->

        <!-- <div class="main-title"></div> -->
        <div class="u-btn apply" id="J-apply" @click="role_handle"></div>
        <div class="m-user">
            <!-- <div class="u-btn login" @click="$mslogin.open()" v-if="!login"></div>
            <span class="user-info" v-if="login">欢迎，{{ ua.uid }}<span class="logout" @click="logout">【退出】</span></span> -->
            <span class="user-info" v-if="login">欢迎，{{ ua.uid }}<span class="logout" @click="call_logout()">【退出】</span></span>
            <span class="user-info" v-else>欢迎，仙术师，请先<span class="u-btn login" @click="$mslogin.open()">登录</span></span>
        </div>        

        <!-- <div class="sponsor"></div>      -->
    </div>
</template>

<style scoped>
.m-head{
    position: relative;
    padding-top: 900px;
    height: 1127px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/cover.jpg);
    background-position: top center;
}

.m-head::before{
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: -50px;
    width: 406px;
    height: 209px;
    background-image: url(~@/assets/images/layer-cloud-left.png);
}

.m-head::after{
    content: '';
    display: block;
    position: absolute;
    right: 0;
    bottom: -50px;
    width: 406px;
    height: 209px;
    background-image: url(~@/assets/images/layer-cloud-right.png);
}

.logo {
    position: absolute;
    left: 30px;
    top: 60px;
    width: 209px;
    height: 159px;
    background-image: url(~@/assets/images/logo.png);
    z-index: 10;
}

.logo a {
    display: block;
    width: 100%;
    height: 100%;
}

.u-web {
    position: absolute;
    left: 150px;
    top: 80px;
    width: 132px;
    height: 41px;
    background-image: url(~@/assets/images/logo-huya.png);
    z-index: 10;
}

.u-web a {
    display: block;
    width: 100%;
    height: 100%;
}

.m-user{
    width: 753px;
    height: 48px;
    line-height: 48px;
    margin: 16px auto 0;
    font-size: 18px;
    color: #fffeff;
    text-align: center;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.m-user .u-btn.login{
    color: #dbaf6e;
}

.user-info{
    font-size: 16px;
    color: #fff;
}

.user-info .logout{
    cursor: pointer;
}

.main-title{
    width: 912px;
    height: 268px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/main-title.png);
}

.u-btn.apply {
    width: 264px;
    height: 67px;
    margin: 0 auto;
    background-image: url(~@/assets/images/btn-signup.png);
}

.u-btn.apply:hover{
    background-image: url(~@/assets/images/btn-signup_hover.png);
}

.sponsor{
    width: 675px;
    height: 36px;
    margin: 40px auto;
    background-image: url(~@/assets/images/sponsor.png);
}
</style>

<script>
export default {
    data (){
        return {
            status : 1,
            now : localStorage.getItem("left"),
        }
    },
    props :{
        ua : {
            default : () => {},
        },
        login : {
            default : 0,
        }          
    },
    methods :{
        call_logout(){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },
        role_handle (){

            if(!this.login)return this.$mslogin.open();

            //return this.$message.error('报名尚未开始！');

            var role = this.ua.role,
                status = this.ua.state;

            if(role == 1){
                //队长
                //队员准备确认
                this.$axios.get(this.$ajax_url_map.players)
                .then(res => {
                    if(res.data.code == this.$ajax_code.success){
                        this.$list_modal({ 
                            member_data : res.data.data.players,
                            code : res.data.data.code,
                            name : res.data.data.name,
                            tid : res.data.data.teamId,
                            zid : res.data.data.players[0].zid,
                            role : role,
                        });
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });

            }
            else if(role == 2 && status == true){
                //队员
                //队员准备确认
                this.$axios.get(this.$ajax_url_map.players)
                .then(res => {
                    if(res.data.code == this.$ajax_code.success){
                        this.$list_modal({ 
                            member_data : res.data.data.players,
                            code : res.data.data.code,
                            name : res.data.data.name,
                            tid : res.data.data.teamId,
                            zid : res.data.data.players[0].zid,
                            role : role,
                        });
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });       
            }
            else{
                if(this.now < 0)return this.$message.error('报名已结束！');
                this.$entrance({
                    ua : this.ua,
                })
            }            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/head.vue